import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ApiMethod } from 'src/app/decorators/api-method.decorator';
import moment from 'moment';
@Injectable({
	providedIn: 'root'
})
export class JobDocumentsService {

	private baseJobUrl = `${environment.baseUrl}/job`;
	private baseProposalUrl = `${environment.baseUrl}/proposal`;

	constructor(private httpClient: HttpClient) { }

	@ApiMethod()
	uploadFiles(token: string, documents: File[], { documentTypeMappingId, description, additionalAssets, documentationAssetTypes, effectiveDate, descriptiveTagId, calendarBasedTagIds }): Observable<void> {

		const formData = new FormData();

		if (documents) {
			documents.forEach(file => formData.append('file[]', file, file.name));
		}

		formData.append('documentTypeMappingId', documentTypeMappingId);
		formData.append('description', description || '');

		if (effectiveDate) {
			formData.append('effectiveDate', moment.parseZone(effectiveDate).format('MM/DD/YYYY'));
		}

		if (descriptiveTagId) {
			formData.append('descriptiveTagId', descriptiveTagId);
		}

		if (additionalAssets) {
			additionalAssets.forEach(item => formData.append('additionalAssetIds[]', item));
		}

		if (documentationAssetTypes) {
			documentationAssetTypes.forEach(item => formData.append('documentationAssetTypeIds[]', item));
		}

		if (calendarBasedTagIds) {
			calendarBasedTagIds.forEach(item => formData.append('calendarBasedTagIds[]', item));
		}

		return this.httpClient.post<void>(`${this.baseJobUrl}/${token}/documents`, formData);
	}

	@ApiMethod()
	getJobDocument(token: string, documentId: number): Observable<Blob> {
		return this.httpClient.get<Blob>(`${this.baseJobUrl}/${token}/documents/${documentId}`, { responseType: 'blob' as 'json' });
	}

	@ApiMethod()
	changeDocumentListDescription(token: string, models: { documentId: number, description: string }[]): Observable<void> {
		return this.httpClient.patch<void>(`${this.baseJobUrl}/${token}/documents/description`, models);
	}

	@ApiMethod()
	getProposalDocument(token: string, documentId: number): Observable<Blob> {
		return this.httpClient.get<Blob>(`${this.baseProposalUrl}/${token}/documents/${documentId}`, { responseType: 'blob' as 'json' });
	}
}
